// NEED TO SUPPORT CAPABILITIES
const DEVICE_FILTER_FIELDS = ['area', 'unit', 'location', 'model', 'deviceStatus'];

export function getAllowedDeviceFilterFields() {
    return DEVICE_FILTER_FIELDS;
}

export const IOT_JOB_PAYLOAD = {
    scope: "DEVICE",
    command: "adbc",
};

export const DEPLOY_MODELS_PAYLOAD = {
    scope: "DEVICE",
    command: "adbc",
    args: {
        command: "update-model",
        s3URI: null,
        targetApp: "ambientMonitoring"
    }
};
